import { handleErrorApi } from '@/shared/lib';
import { createClient } from '@/shared/api';
import type { ClinicTicketCountQuery, ClinicTicketCountQueryVariables } from '@/shared/api';
import CLINIC_TICKET_COUNT from '../queries/clinicTicketCount';

/**
 * Counts the clinic support tickets matching a filter so the tab badge can be rendered. Queries CLINIC_TICKET_COUNT with the filter and unwraps the clinicTicketCount field through the shared error handler.
 *
 * @param filter - Filter criteria for the clinic tickets to count.
 * @returns Promise resolving to the clinic ticket count.
 */
const fetchClinicTicketCount = async (
  filter: ClinicTicketCountQueryVariables['filter'],
): Promise<ClinicTicketCountQuery['clinicTicketCount']> => {
  const client = createClient();
  const result = await client.query<ClinicTicketCountQuery, ClinicTicketCountQueryVariables>({
    query: CLINIC_TICKET_COUNT,
    variables: {
      filter,
    },
  });
  return handleErrorApi(result, 'clinicTicketCount');
};

export default fetchClinicTicketCount;
